import { render, staticRenderFns } from "./bulkAdd.vue?vue&type=template&id=65a3ce53&scoped=true"
import script from "./bulkAdd.vue?vue&type=script&lang=js"
export * from "./bulkAdd.vue?vue&type=script&lang=js"
import style0 from "./bulkAdd.vue?vue&type=style&index=0&id=65a3ce53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a3ce53",
  null
  
)

export default component.exports